import { Interval } from 'luxon';
import { convertHoursToUnit, getCurrentDate, getCurrentTimeInUnit, parseDateTime } from '@utils/dateHelpers';
export function formatSlots(slots) {
    return slots?.reduce((acc, slot) => {
        const date = parseDateTime(slot?.from_date)?.toFormat('yyyy-MM-dd') || '';
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(slot);
        return acc;
    }, {});
}
export const dateCache = {}; // global function for persistent caching
// Caches the parsed UTC "YYYY-MM-DD" date string
export function parseDateTimeWithCache(dateStr) {
    if (!dateCache[dateStr]) {
        const parsedDate = parseDateTime(dateStr);
        dateCache[dateStr] = parsedDate?.toFormat('yyyy-MM-dd') ?? '';
    }
    return dateCache[dateStr];
}
export function groupByDate(entries) {
    const groupedEntries = {};
    for (const entry of entries) {
        let keyValue;
        // Determine which key to use based on the type of entry
        if ('from_date' in entry) {
            keyValue = entry.from_date; // For Slot
        }
        else if ('from' in entry) {
            keyValue = entry.from; // For SchDriveSlots
        }
        // Only proceed if we have a valid key value
        if (typeof keyValue === 'string') {
            const parsedDate = parseDateTimeWithCache(keyValue);
            // Group by parsed date
            if (!groupedEntries[parsedDate]) {
                groupedEntries[parsedDate] = [];
            }
            groupedEntries[parsedDate].push(entry);
        }
    }
    // // Temporary logic: Remove dates with only one slot
    // for (const date in groupedEntries) {
    //   if (groupedEntries[date].length === 1) {
    //     delete groupedEntries[date];
    //   }
    // }
    return groupedEntries;
}
export const convertDriveKeyToSlot = (driveSchedule) => ({
    from_date: driveSchedule.from,
    to_date: driveSchedule.to,
    ...driveSchedule,
});
export const getAllDatesInRange = (start, end) => Interval.fromDateTimes(start.startOf('day'), end.endOf('day'))
    .splitBy({ days: 1 })
    .map((interval) => interval.start?.toFormat('yyyy-MM-dd'))
    .filter((date) => !!date);
/**
 * Validates if a slot action is allowed based on cutoff time
 */
export const validateSlotAction = (driveFrom, cutoffTimeHours) => {
    if (cutoffTimeHours <= 0 || !driveFrom) {
        return true;
    }
    const currentDateTimeMs = getCurrentTimeInUnit('milliseconds');
    const slotDateTime = parseDateTime(driveFrom);
    const slotDateTimeMs = slotDateTime?.toMillis() || 0;
    const cutoffTimeMs = convertHoursToUnit(cutoffTimeHours);
    const actualCutoffTimeMs = slotDateTimeMs - cutoffTimeMs;
    return currentDateTimeMs <= actualCutoffTimeMs;
};
export const isSlotInThePast = (startDate) => {
    if (!startDate)
        return false;
    const currentDate = getCurrentDate();
    const slotStartDateTime = parseDateTime(startDate);
    return Boolean(slotStartDateTime && currentDate && slotStartDateTime < currentDate);
};
// Validates if a slot can be rescheduled (returns true if the remaining time <= 24 hours to the slot time)
export const validateRescheduleAction = (from) => {
    try {
        const currentTime = getCurrentDate();
        const slotStartTime = parseDateTime(from);
        if (!slotStartTime)
            return false;
        const diffInHours = slotStartTime && slotStartTime.diff(currentTime, 'hours').hours;
        if (diffInHours)
            return diffInHours <= 24;
        return false;
    }
    catch {
        return false;
    }
};
